import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const Navigation: React.FC = () => {
  const location = useLocation();
  
  const links = [
    { path: '/create', label: 'CREATE' },
    { path: '/blinks', label: 'BLINKS' },
    { path: '/rewards', label: 'REWARDS' },
    { path: '/docs', label: 'DOCS' },
    { path: '/history', label: 'HISTORY' },
    { path: '/how-to-play', label: 'HOW TO PLAY' },
  ];

  return (
    <div className="navigation">
      {links.map((link) => {
        // Handle root path for create page
        const isActive = link.path === '/create' 
          ? (location.pathname === '/' || location.pathname === '/create')
          : location.pathname === link.path;

        return (
          <NavLink
            key={link.path}
            to={link.path}
            className={`nav-link ${isActive ? 'active' : ''}`}
          >
            {link.label}
          </NavLink>
        );
      })}
    </div>
  );
};

export default Navigation;
